import type { AxiosInstance, AxiosResponse } from 'axios'
import type {
  RequestClientConfig,
  RequestClientOptions,
  HttpSuccessResponse,
} from './types'
import defu from 'defu'
import axios from 'axios'
// import qs from 'qs'
import * as qs from 'qs'
import { isString } from '@vue/shared'
import { bindMethods } from '@el-plus/utils/utils'
import { InterceptorManager } from './modules/interceptor'
function getParamsSerializer(
  paramsSerializer: RequestClientOptions['paramsSerializer'],
) {
  if (isString(paramsSerializer)) {
    switch (paramsSerializer) {
      case 'brackets': {
        return (params: any) =>
          qs.stringify(params, { arrayFormat: 'brackets' })
      }
      case 'comma': {
        return (params: any) => qs.stringify(params, { arrayFormat: 'comma' })
      }
      case 'indices': {
        return (params: any) => qs.stringify(params, { arrayFormat: 'indices' })
      }
      case 'repeat': {
        return (params: any) => qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
  }
  return paramsSerializer
}

class RequestClient {
  public readonly instance: AxiosInstance
  // 拦截器
  public addRequestInterceptor: InterceptorManager['addRequestInterceptor']
  public addResponseInterceptor: InterceptorManager['addResponseInterceptor']
  constructor(options: RequestClientOptions = {}) {
    // 合并默认配置和传入的配置
    const defaultConfig: RequestClientOptions = {
      headers: {
        'Content-Type': 'application/json;charset=utf-8',
      },
      responseReturn: 'raw',
      // 默认超时时间10s
      timeout: 10_000,
    }
    const { ...axiosConfig } = options
    const requestConfig = defu(axiosConfig, defaultConfig)
    // requestConfig.paramsSerializer = getParamsSerializer(
    //   requestConfig.paramsSerializer,
    // )
    this.instance = axios.create(requestConfig)

    bindMethods(this)

    // 实例化拦截器管理器
    const interceptorManager = new InterceptorManager(this.instance)
    this.addRequestInterceptor =
      interceptorManager.addRequestInterceptor.bind(interceptorManager)
    this.addResponseInterceptor =
      interceptorManager.addResponseInterceptor.bind(interceptorManager)
  }

  /**
   * DELETE请求方法
   */
  public delete<T = any, R = HttpSuccessResponse<T>>(
    url: string,
    data?: any,
    config?: RequestClientConfig,
  ): Promise<R> {
    return this.request<T>(url, {
      ...config,
      data,
      method: 'DELETE',
    }) as Promise<R>
  }

  /**
   * GET请求方法
   */
  public get<T = any, R = HttpSuccessResponse<T>>(
    url: string,
    params?: any,
    config?: RequestClientConfig,
  ): Promise<R> {
    return this.request<T>(url, {
      ...config,
      method: 'GET',
      params,
    }) as Promise<R>
  }

  /**
   * 获取基础URL
   */
  public getBaseUrl() {
    return this.instance.defaults.baseURL
  }

  /**
   * POST请求方法
   */
  public post<T = any, R = HttpSuccessResponse<T>>(
    url: string,
    data?: any,
    config?: RequestClientConfig,
  ): Promise<R> {
    return this.request(url, { ...config, data, method: 'POST' }) as Promise<R>
  }

  /**
   * PUT请求方法
   */
  public put<T = any, R = HttpSuccessResponse<T>>(
    url: string,
    data?: any,
    config?: RequestClientConfig,
  ): Promise<R> {
    return this.request(url, { ...config, data, method: 'PUT' }) as Promise<R>
  }

  /**
   * 通用的请求方法
   */
  public async request<T, R = HttpSuccessResponse<T>>(
    url: string,
    config: RequestClientConfig,
  ): Promise<R> {
    try {
      const response: AxiosResponse<R> = await this.instance({
        url,
        ...config,
        // ...(config.paramsSerializer
        //   ? { paramsSerializer: getParamsSerializer(config.paramsSerializer) }
        //   : {}),
      })
      return response as R
    } catch (error: any) {
      throw error.response ? error.response.data : error
    }
  }
}
export { RequestClient }
